module.exports = __webpack_public_path__ + "static/media/ic_close.675ac406.svg";